import { ArraySerializer, deserialize, Field, Model, PrimitiveSerializer, Type } from 'serialize-ts';
import { BestOffer } from './best-offer.model';
import { Attributes } from './attributes.model';
import { ModelMetadataSerializer } from 'serialize-ts/dist/serializers/model-metadata.serializer';
import { CheapestOffer } from '~shared/models/product-card/cheapest-offer.model';
import { Category } from '~app/modules/generic/models';
import { Variant } from '~shared/models/product-card/product-variant.model';

@Model()
export class Product {
  @Field()
  id: string;

  @Field()
  mid: string;

  @Field()
  name: string;

  @Field()
  image: string;

  @Field()
  bestOffer: BestOffer;

  @Field()
  cheapestOffers?: CheapestOffer;

  @Field()
  @Type(new ArraySerializer(new PrimitiveSerializer()))
  categories: Category[];

  @Field()
  @Type(new ModelMetadataSerializer(Attributes))
  attributes: Attributes;

  @Field()
  hasPromotion: boolean;

  variant?: Variant;

  @Field()
  @Type(new ArraySerializer(new PrimitiveSerializer()))
  tags: string[];

  public static map(response: any): Product {
    const product = deserialize(response, Product);
    let bestOffer = response.bestOffer;
    product.bestOffer = (bestOffer && BestOffer.map(bestOffer, product.hasPromotion)) || null;

    product.attributes = response.attributes && Attributes.map(response.attributes);

    if (response?.variant) {
      product.variant = response.variant;
    }

    return product;
  }
}
